import { useMemo } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import routesConfig from '@/routes/routesConfig';

const useJSXRoutes = () => {
  return useMemo(() => createBrowserRouter(routesConfig()), []);
};

export default useJSXRoutes;
